export default __webpack_public_path__ + "static/media/Shreya.220dfcc2.jpg";